module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/6bacea0285bb005dd1143fd40478d644.svg";